<template>
  <svg
    id="youarehere"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 350 150"
    :x="milestoneCoords.x"
    :y="milestoneCoords.y"
    width="350"
    height="150"
  >
    <g id="RedSign">
      <g id="Bubble">
        <path
          class="cls-1"
          d="M163.4,102.8h4a4,4,0,0,0-4-4Zm0,18.6h-4a4,4,0,0,0,3.1,3.9,4,4,0,0,0,4.5-2.2Zm8.9-18.6v-4a4.1,4.1,0,0,0-3.6,2.3ZM55.5,52.4a13,13,0,0,1,13-13v-8a21,21,0,0,0-21,21Zm0,33.4V52.4h-8V85.7h8Zm13,13a13,13,0,0,1-13-13h-8a21,21,0,0,0,21,21Zm94.9,0H68.5v8h94.8v-8Zm4,22.6V102.8h-8v18.6Zm1.3-20.4-9,18.6,7.2,3.5,9-18.6Zm80.1-2.2H172.3v8h76.5Zm13-13a13,13,0,0,1-13,13v8a21,21,0,0,0,21-21Zm0-33.4V85.7h8V52.4Zm-13-13a13,13,0,0,1,13,13h8a21,21,0,0,0-21-21Zm-180.3,0H248.7v-8H68.5Z"
          transform="translate(0.5 0.5)"
        />
        <path
          class="cls-2"
          d="M68.5,35.4a17,17,0,0,0-17,17V85.7a17,17,0,0,0,17,17h94.8v18.6l9-18.6h76.5a17,17,0,0,0,17-17V52.4a17,17,0,0,0-17-17Z"
          transform="translate(0.5 0.5)"
        />
        <path
          id="yourehere"
          class="cls-1"
          d="M84.5,60.7H81.7c-.8,0-1,.2-1.1.8s1.1,1.8-.4,4.7l-1.6,3.1-1.9-3.1c-1.9-3.1-.4-3.3-.6-4.7s-.6-.8-1.3-.8H69.7c-.8,0-1.1.2-1.1.8s1.1,1.2,3.2,4.7l3.3,5.3V72c0,1.7,0,2.9-.5,3.5s-.8,1.2-.8,1.6.4.7,1.1.7h4.9c.8,0,1.1-.2,1.1-.7s-.2-.8-.8-1.6a7.3,7.3,0,0,1-.5-3.5v-.6l2.7-5.1c1.8-3.4,3.3-3.4,3.3-4.7S85.2,60.7,84.5,60.7Zm5.8,4.9c-4.1,0-6.7,2.4-6.7,6.2S86.2,78,90.3,78s6.6-2.4,6.6-6.2S94.3,65.6,90.3,65.6Zm0,10.1c-1.4,0-2.1-1.7-2.1-3.9s.7-3.9,2.1-3.9,2.1,1.6,2.1,3.9S91.7,75.7,90.3,75.7Zm21.1-.8c-.5-.5-.5-2-.5-3.7V67.4c0-1.4-.7-2-2.1-1.6l-2.5.8c-.7.2-1.1.6-1.1,1.1s.1.8.8,1.6.5,1.4.5,3.1v.8c0,1.5-.6,2.3-1.6,2.3s-1.8-2.1-1.8-3.8V67.5c0-1.4-.7-2-2.1-1.6l-2.5.8c-.7.2-1.1.6-1.1,1.1s.1.8.8,1.6.5,1.4.5,3.1v1.7a3.9,3.9,0,0,0,4.3,4.1,4.3,4.3,0,0,0,3.7-1.6c.4,1,1.3,1.6,3.1,1.6s2.7-.8,2.8-1.9S112,75.4,111.4,74.9Zm4.3-15.5a2.2,2.2,0,0,0-.2,4.4,4.1,4.1,0,0,1-.7,1.7c-.7,1,.1,1.6,1,1a5.7,5.7,0,0,0,2.2-4.6C117.9,60.3,117,59.4,115.7,59.4Zm12.1,6.2a3.8,3.8,0,0,0-2.9,1.3c-.1-1-.9-1.5-2.1-1.2l-2.4.8c-.8.2-1.1.6-1.1,1.1s.1.8.8,1.6.5,1.5.5,3.2,0,2.4-.5,3.1-.8,1.2-.8,1.6.4.7,1.1.7h4.9c.8,0,1-.2,1.1-.7s-.3-.9-1-1.6-.5-1.4-.5-3.1v-3c0-.8.2-1.2.8-1.2s.7.8,1.3,1.7a2.1,2.1,0,0,0,3.4-.2A2.7,2.7,0,0,0,127.8,65.6Zm14.4,8.6c-2,1.9-6.1,1.4-6.6-1.7h6c1.6,0,1.9-.6,1.7-2.3a5.3,5.3,0,0,0-5.5-4.6c-3.7-.1-6.9,2.1-6.8,6.3s3.5,6,6.9,6a5.4,5.4,0,0,0,5.3-3.1C143.6,74,142.9,73.5,142.2,74.2Zm-4.8-6.6a1.8,1.8,0,0,1,2,1.6c.2.7-.1,1.1-.7,1.1h-2.9c-.2,0-.3-.2-.3-.5S136.3,67.7,137.4,67.6Zm26.3,7.8c-.4-.6-.5-1.4-.5-3.1V69.7c0-1.9-1.1-4-4.3-4a5,5,0,0,0-3.5,1.5V62.3c0-1.4-.7-2-2.1-1.7l-2.4.8c-.8.2-1.1.6-1.1,1.1s.1.8.8,1.6.5,1.4.5,3.1v5.1c0,1.7,0,2.5-.5,3.1s-.8,1.2-.8,1.6.4.7,1.1.7h4.7c.8,0,1.1-.2,1.1-.7s-.1-.8-.8-1.6-.5-1.4-.5-3.1V70.6c0-1.5.6-2.3,1.7-2.3s1.7,2.1,1.7,3.8v.2c0,1.7,0,2.5-.5,3.1s-.8,1.2-.8,1.6.4.7,1.1.7h4.7c.8,0,1.1-.2,1.1-.7S164.4,76.3,163.7,75.4Zm12.6-1.2c-2,1.9-6.1,1.4-6.6-1.7h6c1.6,0,1.9-.6,1.7-2.3a5.3,5.3,0,0,0-5.5-4.6c-3.7-.1-6.9,2.1-6.8,6.3s3.5,6,6.9,6a5.4,5.4,0,0,0,5.3-3.1C177.7,74,177,73.5,176.3,74.2Zm-4.8-6.6a1.8,1.8,0,0,1,2,1.6c.2.7-.1,1.1-.7,1.1h-2.9c-.2,0-.3-.2-.3-.5S170.4,67.7,171.5,67.6Zm15.5-2a3.8,3.8,0,0,0-2.9,1.3c-.1-1-.9-1.5-2.1-1.2l-2.4.8c-.8.2-1.1.6-1.1,1.1s.1.8.8,1.6.5,1.5.5,3.2,0,2.4-.5,3.1-.8,1.2-.8,1.6.4.7,1.1.7h4.9c.8,0,1-.2,1.1-.7s-.3-.9-1-1.6-.5-1.4-.5-3.1v-3c0-.8.2-1.2.8-1.2s.7.8,1.3,1.7a2.1,2.1,0,0,0,3.4-.2A2.7,2.7,0,0,0,187,65.6Zm14.5,8.6c-2,1.9-6.1,1.4-6.6-1.7h6c1.6,0,1.9-.6,1.7-2.3a5.3,5.3,0,0,0-5.5-4.6c-3.7-.1-6.9,2.1-6.8,6.3s3.5,6,6.9,6a5.4,5.4,0,0,0,5.3-3.1C202.8,74,202.2,73.5,201.5,74.2Zm-4.8-6.6a1.8,1.8,0,0,1,2,1.6c.2.7-.1,1.1-.7,1.1h-2.9c-.2,0-.3-.2-.3-.5S195.6,67.7,196.7,67.6Zm9.6,6a2.2,2.2,0,0,0-2.3,2.2,2.1,2.1,0,0,0,2.3,2.2,2.2,2.2,0,0,0,0-4.4Zm0-13.1c-1.9,0-2.8,1.5-2.4,3.7s.3,1.8,1.1,6.2c.2,1.3.3,2,1.2,2s1-.7,1.2-2c.8-4.4.9-4.8,1.1-6.2S208.1,60.5,206.3,60.5Z"
          transform="translate(0.5 0.5)"
        />
      </g>
      <g id="Arrow">
        <line
          id="Line_32"
          data-name="Line 32"
          class="cls-3"
          x1="238.1"
          y1="59.5"
          x2="238.1"
          y2="76.8"
        />
        <path
          id="Rectangle_699"
          data-name="Rectangle 699"
          class="cls-3"
          d="M229.8,73.5l7.8,7.8,7.8-7.8"
          transform="translate(0.5 0.5)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig"]),
    milestoneCoords() {
      return this.$store.getters.milestoneCoords;
    },
  },
  methods: {
    hereAnim() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#youarehere",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 3,
            ease: "elastic.out(1.2, 0.2)",
            transformOrigin: "50% 100%",
          },
        })
        .add("here")
        .from(
          "#RedSign",
          {
            rotation: -25,
          },
          "here"
        );
    },
  },
  mounted() {
    this.hereAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1,
.cls-4 {
  fill: #fff;
}

.cls-2 {
  fill: #ff2260;
  fill-rule: evenodd;
}

.cls-3 {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 6px;
}

.cls-4 {
  stroke: #000;
  stroke-miterlimit: 10;
}
</style>